export default __webpack_public_path__ + "static/media/ZIDbpB4rgnY.f26d2d75.jpg";